// Desktop assets can load before the embedded backend starts listening. A
// failed request is not evidence that user management is enabled or disabled.
export const loadUserManagementState = async (
  url: string,
  signal: AbortSignal,
  fetcher: typeof fetch = fetch,
  retryDelayMs = 1500,
): Promise<boolean> => {
  while (!signal.aborted) {
    try {
      const response = await fetcher(url, { cache: "no-store", signal });
      if (response.ok) {
        const payload = await response.json() as {
          userManagementEnabled?: unknown;
          userManagementDisabled?: unknown;
        } | null;
        signal.throwIfAborted();
        if (typeof payload?.userManagementEnabled === "boolean") {
          return payload.userManagementEnabled;
        }
        if (typeof payload?.userManagementDisabled === "boolean") {
          return !payload.userManagementDisabled;
        }
      }
    } catch {
      signal.throwIfAborted();
    }

    await new Promise<void>((resolve, reject) => {
      const onAbort = () => {
        clearTimeout(timer);
        reject(signal.reason);
      };
      const timer = setTimeout(() => {
        signal.removeEventListener("abort", onAbort);
        resolve();
      }, retryDelayMs);
      signal.addEventListener("abort", onAbort, { once: true });
      if (signal.aborted) onAbort();
    });
  }
  throw signal.reason;
};
